import { render, staticRenderFns } from "./request_change_amount.vue?vue&type=template&id=6b510d19&"
import script from "./request_change_amount.vue?vue&type=script&lang=js&"
export * from "./request_change_amount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports